import { useMemo } from "react";
import useChartSelections from "components/charting/hooks/useChartSelections";
import useGetOneRepMaxesByAthleteIdsQuery from "hooks/useGetOneRepMaxesByAthleteIdsQuery";
import { MetadataType } from "types/metadata";
import type { UseQueryOptions } from "types/use-query";
import OneRepMaxChartHelpers from "../helpers/OneRepMaxChartHelpers";

// Shares the chart's request, but keeps the entries outside the selected period.
function useOneRepMaxEntries(options?: Pick<UseQueryOptions, "enabled">) {
  const selections = useChartSelections();
  const measure = selections.measures[0];
  const source = selections.sources[0];

  const exerciseId = measure?.type === MetadataType.EXERCISE ? measure.metadata.id : null;
  const athleteIds = useMemo(() => (source?.id ? [source.id] : []), [source]);

  const { data } = useGetOneRepMaxesByAthleteIdsQuery(exerciseId, athleteIds, { mostRecent: false }, options);

  return useMemo(() => OneRepMaxChartHelpers.getManualEntries(data), [data]);
}

export default useOneRepMaxEntries;
